import { render, staticRenderFns } from "./AccountBody.vue?vue&type=template&id=66544f94&"
import script from "./AccountBody.vue?vue&type=script&lang=js&"
export * from "./AccountBody.vue?vue&type=script&lang=js&"
import style0 from "./AccountBody.vue?vue&type=style&index=0&id=66544f94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Banner: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/Banner.vue').default})
